<template>
    <div>
        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text ma-1">
                    <v-icon>fas fa-ellipsis-v</v-icon>
                </v-btn>
            </template>
             <v-list>
                <v-list-item disabled>
                    <v-list-item-title>
                        Lista de raya: {{  item.fechaInicio }} - {{ item.fechaFin }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click.prevent="downloadRaya(item)">
                    <v-list-item-title>
                        <v-icon small class="mr-2">fas fa-download</v-icon>
                        Descargar lista de raya
                    </v-list-item-title>
                </v-list-item>
                <v-list-item @click.prevent="showDetailRaya(item)">
                    <v-list-item-title>
                        <v-icon small class="mr-2">fas fa-list</v-icon>
                        Detalle de raya
                    </v-list-item-title>
                </v-list-item>
             </v-list>
        </v-menu>
    </div>
</template>
<script>
export default {
    name: "ActionRaya",
    props: {
        item: { type: Object },
        downloadRaya: { type: Function },
        showDetailRaya: { type: Function },
    }
}
</script>